import localec6ef1140 from '../../locales/fr-fr.js'
import localec76b9eee from '../../locales/fr-be.js'
import localec74cb5b2 from '../../locales/fr-ch.js'
import localec6433cfa from '../../locales/fr-lu.js'

export const Constants = {
  COMPONENT_OPTIONS_KEY: "nuxtI18n",
  STRATEGIES: {"PREFIX":"prefix","PREFIX_EXCEPT_DEFAULT":"prefix_except_default","PREFIX_AND_DEFAULT":"prefix_and_default","NO_PREFIX":"no_prefix"},
  REDIRECT_ON_OPTIONS: {"ALL":"all","ROOT":"root","NO_PREFIX":"no prefix"},
}
export const nuxtOptions = {
  isUniversalMode: true,
  trailingSlash: true,
}
export const options = {
  vueI18n: {},
  vueI18nLoader: false,
  locales: [{"code":"fr-fr","iso":"fr-FR","countryIsoCode":"FR","lang":"fr","file":"fr-fr.js"},{"code":"fr-be","iso":"fr-BE","countryIsoCode":"BE","lang":"fr","file":"fr-be.js"},{"code":"fr-ch","iso":"fr-CH","countryIsoCode":"CH","lang":"fr","file":"fr-ch.js"},{"code":"fr-lu","iso":"fr-LU","countryIsoCode":"LU","lang":"fr","file":"fr-lu.js"}],
  defaultLocale: "fr-fr",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  defaultLocaleRouteNameSuffix: "default",
  sortRoutes: true,
  strategy: "prefix_except_default",
  lazy: false,
  langDir: "locales/",
  rootRedirect: null,
  detectBrowserLanguage: {"alwaysRedirect":false,"cookieAge":365,"cookieCrossOrigin":false,"cookieDomain":null,"cookieKey":"i18n_redirected","cookieSecure":false,"fallbackLocale":"","redirectOn":"root","useCookie":true},
  differentDomains: false,
  baseUrl: "https://www.escrime-occasion.com",
  vuex: {"moduleName":"i18n","syncRouteParams":true},
  parsePages: false,
  pages: {"g/confirm-email":false,"g/change-password":false,"auth/login":{"fr-fr":"/connexion/","fr-ch":"/connexion/","en-ch":"/sign-in/","fr-be":"/connexion/","en-be":"/sign-in/"},"auth/register":{"fr-fr":"/inscription/","fr-ch":"/inscription/","en-ch":"/sign-up/","fr-be":"/inscription/","en-be":"/sign-up/"},"auth/forgot-password":{"fr-fr":"/mot-de-passe-oublie/","fr-ch":"/mot-de-passe-oublie/","en-ch":"/forgot-password/","fr-be":"/mot-de-passe-oublie/","en-be":"/forgot-password/"},"auth/change-password":{"fr-fr":"/changer-mon-mot-de-passe/","fr-ch":"/changer-mon-mot-de-passe/","en-ch":"/change-password/","fr-be":"/changer-mon-mot-de-passe/","en-be":"/change-password/"},"post-offer":{"fr-fr":"/deposer-une-annonce/","fr-ch":"/deposer-une-annonce/","en-ch":"/post-offer/","fr-be":"/deposer-une-annonce/","en-be":"/post-offer/"},"legal/general-terms-of-sale":{"fr-fr":"/conditions-generales-de-vente/","fr-ch":"/conditions-generales-de-vente/","en-ch":"/general-terms-of-sale/","fr-be":"/conditions-generales-de-vente/","en-be":"/general-terms-of-sale/"},"legal/general-terms-of-use":{"fr-fr":"/conditions-generales-d-utilisation/","fr-ch":"/conditions-generales-d-utilisation/","en-ch":"/general-terms-of-use/","fr-be":"/conditions-generales-d-utilisation/","en-be":"/general-terms-of-use/"},"legal/legal-mention":{"fr-fr":"/mentions-legales/","fr-ch":"/mentions-legales/","en-ch":"/legal-notice/","fr-be":"/mentions-legales/","en-be":"/legal-notice/"},"legal/privacy-policy":{"fr-fr":"/politique-de-confidentialite/","fr-ch":"/politique-de-confidentialite/","en-ch":"/privacy-policy/","fr-be":"/politique-de-confidentialite/","en-be":"/privacy-policy/"},"offers/_slug/index":{"fr-fr":"/annonces/:slug/","fr-ch":"/annonces/:slug/","en-ch":"/offers/:slug/","fr-be":"/annonces/:slug/","en-be":"/offers/:slug/"},"offers/_slug/message":{"fr-fr":"/annonces/:slug/message","fr-ch":"/annonces/:slug/message","en-ch":"/offers/:slug/message","fr-be":"/annonces/:slug/message","en-be":"/offers/:slug/message"},"offers/_slug/map":{"fr-fr":"/annonces/:slug/map","fr-ch":"/annonces/:slug/map","en-ch":"/offers/:slug/map","fr-be":"/annonces/:slug/map","en-be":"/offers/:slug/map"},"categories/index":{"fr-fr":"/categories/","fr-ch":"/categories/","en-ch":"/categories/","fr-be":"/categories/","en-be":"/categories/"},"categories/_slug":{"fr-fr":"/categories/:slug/","fr-ch":"/categories/:slug/","en-ch":"/categories/:slug/","fr-be":"/categories/:slug/","en-be":"/categories/:slug/"},"brands/index":{"fr-fr":"/marques/","fr-ch":"/marques/","en-ch":"/brands/","fr-be":"/marques/","en-be":"/brands/"},"brands/_slug":{"fr-fr":"/marques/:slug/","fr-ch":"/marques/:slug/","en-ch":"/brands/:slug/","fr-be":"/marques/:slug/","en-be":"/brands/:slug/"},"profile/_username":{"fr-fr":"/profil/:username/","fr-ch":"/profil/:username/","en-ch":"/profile/:username/","fr-be":"/profil/:username/","en-be":"/profile/:username/"},"contact":{"fr-fr":"/nous-contacter/","fr-ch":"/nous-contacter/","en-ch":"/contact-us/","fr-be":"/nous-contacter/","en-be":"/contact-us/"},"maintenance":{"fr-fr":"/maintenance/","fr-ch":"/maintenance/","en-ch":"/maintenance/","fr-be":"/maintenance/","en-be":"/maintenance/"},"search":{"fr-fr":"/recherche/","fr-ch":"/recherche/","en-ch":"/search/","fr-be":"/recherche/","en-be":"/search/"},"account":{"fr-fr":"/compte/","fr-ch":"/compte/","en-ch":"/account/","fr-be":"/compte/","en-be":"/account/"},"account/associated-accounts":{"fr-fr":"/compte/comptes-associes/","fr-ch":"/compte/comptes-associes/","en-ch":"/account/associated-account/","fr-be":"/compte/comptes-associes/","en-be":"/account/associated-account/"},"account/change-pass":{"fr-fr":"/compte/modifier-mon-mot-de-passe/","fr-ch":"/compte/modifier-mon-mot-de-passe/","en-ch":"/account/edit-my-password/","fr-be":"/compte/modifier-mon-mot-de-passe/","en-be":"/account/edit-my-password/"},"account/info":{"fr-fr":"/compte/mes-informations/","fr-ch":"/compte/mes-informations/","en-ch":"/account/my-information/","fr-be":"/compte/mes-informations/","en-be":"/account/my-information/"},"account/edit-profile":{"fr-fr":"/compte/mon-profil/","fr-ch":"/compte/mon-profil/","en-ch":"/account/my-profile/","fr-be":"/compte/mon-profil/","en-be":"/account/my-profile/"},"account/wallet":{"fr-fr":"/compte/portefeuille/","fr-ch":"/compte/portefeuille/","en-ch":"/account/wallet/","fr-be":"/compte/portefeuille/","en-be":"/account/wallet/"},"account/likes":{"fr-fr":"/compte/mes-favoris/","fr-ch":"/compte/mes-favoris/","en-ch":"/account/likes/","fr-be":"/compte/mes-favoris/","en-be":"/account/likes/"},"account/messages":{"fr-fr":"/compte/mes-messages/","fr-ch":"/compte/mes-messages/","en-ch":"/account/messages/","fr-be":"/compte/mes-messages/","en-be":"/account/messages/"},"account/offer-edit":{"fr-fr":"/compte/mes-annonces/editer/","fr-ch":"/compte/mes-annonces/editer/","en-ch":"/account/my-offers/edit/","fr-be":"/compte/mes-annonces/editer/","en-be":"/account/my-offers/edit/"},"account/offers":{"fr-fr":"/compte/mes-annonces/","fr-ch":"/compte/mes-annonces/","en-ch":"/account/offers/","fr-be":"/compte/mes-annonces/","en-be":"/account/offers/"},"account/settings":{"fr-fr":"/compte/parametres/","fr-ch":"/compte/parametres/","en-ch":"/account/settings/","fr-be":"/compte/parametres/","en-be":"/account/settings/"},"account/transactions":{"fr-fr":"/compte/mes-transactions/","fr-ch":"/compte/mes-transactions/","en-ch":"/account/my-transactions/","fr-be":"/compte/mes-transactions/","en-be":"/account/my-transactions/"}},
  skipSettingLocaleOnNavigate: false,
  onBeforeLanguageSwitch: () => {},
  onLanguageSwitched: () => null,
  normalizedLocales: [{"code":"fr-fr","iso":"fr-FR","countryIsoCode":"FR","lang":"fr","file":"fr-fr.js"},{"code":"fr-be","iso":"fr-BE","countryIsoCode":"BE","lang":"fr","file":"fr-be.js"},{"code":"fr-ch","iso":"fr-CH","countryIsoCode":"CH","lang":"fr","file":"fr-ch.js"},{"code":"fr-lu","iso":"fr-LU","countryIsoCode":"LU","lang":"fr","file":"fr-lu.js"}],
  localeCodes: ["fr-fr","fr-be","fr-ch","fr-lu"],
  additionalMessages: [],
}
export const localeFiles = {
  0: "{",
  1: "\"",
  2: "f",
  3: "r",
  4: "-",
  5: "f",
  6: "r",
  7: ".",
  8: "j",
  9: "s",
  10: "\"",
  11: ":",
  12: "\"",
  13: ".",
  14: ".",
  15: "/",
  16: "l",
  17: "o",
  18: "c",
  19: "a",
  20: "l",
  21: "e",
  22: "s",
  23: "/",
  24: "f",
  25: "r",
  26: "-",
  27: "f",
  28: "r",
  29: ".",
  30: "j",
  31: "s",
  32: "\"",
  33: ",",
  34: "\"",
  35: "f",
  36: "r",
  37: "-",
  38: "b",
  39: "e",
  40: ".",
  41: "j",
  42: "s",
  43: "\"",
  44: ":",
  45: "\"",
  46: ".",
  47: ".",
  48: "/",
  49: "l",
  50: "o",
  51: "c",
  52: "a",
  53: "l",
  54: "e",
  55: "s",
  56: "/",
  57: "f",
  58: "r",
  59: "-",
  60: "b",
  61: "e",
  62: ".",
  63: "j",
  64: "s",
  65: "\"",
  66: ",",
  67: "\"",
  68: "f",
  69: "r",
  70: "-",
  71: "c",
  72: "h",
  73: ".",
  74: "j",
  75: "s",
  76: "\"",
  77: ":",
  78: "\"",
  79: ".",
  80: ".",
  81: "/",
  82: "l",
  83: "o",
  84: "c",
  85: "a",
  86: "l",
  87: "e",
  88: "s",
  89: "/",
  90: "f",
  91: "r",
  92: "-",
  93: "c",
  94: "h",
  95: ".",
  96: "j",
  97: "s",
  98: "\"",
  99: ",",
  100: "\"",
  101: "f",
  102: "r",
  103: "-",
  104: "l",
  105: "u",
  106: ".",
  107: "j",
  108: "s",
  109: "\"",
  110: ":",
  111: "\"",
  112: ".",
  113: ".",
  114: "/",
  115: "l",
  116: "o",
  117: "c",
  118: "a",
  119: "l",
  120: "e",
  121: "s",
  122: "/",
  123: "f",
  124: "r",
  125: "-",
  126: "l",
  127: "u",
  128: ".",
  129: "j",
  130: "s",
  131: "\"",
  132: "}",
}

export const localeMessages = {
  'fr-fr.js': () => Promise.resolve(localec6ef1140),
  'fr-be.js': () => Promise.resolve(localec76b9eee),
  'fr-ch.js': () => Promise.resolve(localec74cb5b2),
  'fr-lu.js': () => Promise.resolve(localec6433cfa),
}
